import { Component, OnInit } from '@angular/core';
import {GridDataResult, PageChangeEvent} from '@progress/kendo-angular-grid';
import {EmpresasService} from "../../superadmin/services/empresas.service";

@Component({
  selector: 'app-historico-pausas',
  templateUrl: './historico-pausas.component.html',
  styleUrls: ['./historico-pausas.component.scss']
})
export class HistoricoPausasComponent implements OnInit {
  gridView: GridDataResult = {
    data: [],
    total: 0
  };
  public pageSize = 10;
  public skip = 0;
  public carregando = false;
  public total = 0;

  constructor(private empresaService: EmpresasService) {}

  ngOnInit() {
    this.carregarDados();
  }

  public onPageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take;
    this.carregarDados();
  }

  private carregarDados(): void {
    this.carregando = true;
    this.empresaService.listePausasProgramadas(this.skip, this.pageSize)
      .then((resposta: any) => {
        this.gridView = {
          data: resposta.pausas,
          total: resposta.total,
        }

        this.carregando = false;
      })
      .catch(erro => {
        console.error('Erro ao carregar histórico de pausas:', erro);
        this.carregando = false;
      });
  }
}
